
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/our-boxes",
      function () {
        return require("private-next-pages/our-boxes/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/our-boxes"])
      });
    }
  